<form [formGroup]="pinForm" class="w-100" method="POST" (ngSubmit)="createPin()">
<div class="container-fluid px-0">
  <div class="row  mx-0 my-0 h-100">
    <div class="col-12 px-0 d-flex justify-content-center">
      <div *ngIf="errorMessage" class="error-message">
        <pa-message [description]="errorMessage" [width]="513" (messageState)="messageState($event)"></pa-message>
      </div>
    </div>
    <div class="col-12 px-0 d-flex justify-content-center">
      <div class="rectangle">
        <div class="col-12 px-0 d-flex">
          <label class="title">Üye Girişi</label>
        </div>
        <div class="col-12 px-0 d-flex">
          <mat-form-field class="input-style">
            <mat-label>6 haneli yeni şifre belirleyin</mat-label>
            <input formControlName="pin"
                   type="password" pattern="[0-9]*" inputmode="numeric"
                   autocomplete="off"
                   minlength="6"
                   maxlength="6"
                   matInput
                   tbOnlyNumber>
            <mat-error
              *ngIf="submitted && pinForm.controls.pin.errors && pinForm.controls.pin.errors.required">
              6 haneli yeni şifre belirleyin.
            </mat-error>
            <mat-error
              *ngIf="submitted && pinForm.controls.pin.errors && pinForm.controls.pin.errors.minlength">
              Belirlediğiniz şifre 6 haneli olmalı.
            </mat-error>
          </mat-form-field>
        </div>
        <div class="col-12 px-0 d-flex">
          <mat-form-field class="input-style">
            <mat-label>6 haneli yeni şifrenizi doğrulayın</mat-label>
            <input formControlName="repin"
                   type="password" pattern="[0-9]*" inputmode="numeric"
                   autocomplete="off"
                   minlength="6"
                   maxlength="6"
                   matInput
                   tbOnlyNumber>
            <mat-error
              *ngIf="submitted && pinForm.controls.repin.errors.required">
              6 haneli yeni şifrenizi doğrulayın.
            </mat-error>
            <mat-error
              *ngIf="pinForm.controls.repin.hasError('notSame')">
              Hatalı şifre girdiniz
            </mat-error>
          </mat-form-field>
        </div>
        <div class="col-12 d-flex button-div">
          <button type="submit"
                  [disabled]="pinForm.invalid"
                  [ngClass]="(pinForm.valid) ? 'button-style':'button-style-passive'">
            <span class="text-style">Giriş Yap</span></button>
        </div>
      </div>
    </div>
  </div>
</div>
</form>
